const isTest = process.env.NODE_ENV === 'test';
const delay = (duration: number = isTest ? 1 : 1000) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};
export default delay;
